import { RootState } from 'redux/types'

import DonateVoucherState from './types'

const getDonateVoucherState = (state: RootState): DonateVoucherState => state.account.donateVoucher

const getIsDonateVoucherModalOpen = (state: RootState): boolean =>
  getDonateVoucherState(state).isDonateVoucherModalOpen

export default {
  getIsDonateVoucherModalOpen,
}
